import { render, staticRenderFns } from "./Nbxx.vue?vue&type=template&id=a077bbce&scoped=true"
import script from "./Nbxx.vue?vue&type=script&lang=js"
export * from "./Nbxx.vue?vue&type=script&lang=js"
import style0 from "./Nbxx.vue?vue&type=style&index=0&id=a077bbce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a077bbce",
  null
  
)

export default component.exports